import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Radio,
  Pagination,
  Modal,
  createTheme,
  ThemeProvider,
  CircularProgress,
  IconButton,
  TextField,
} from "@mui/material";
import "@fontsource/manrope";
import { getqtestAllProjects } from "../../services/webServices";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

const theme = createTheme({
  typography: {
    fontFamily: "Manrope, Arial, sans-serif",
  },
});

const QTestProjectsComponentPages = ({
  taskType,
  issueType,
  projectsLoading,
  setOpenProjectPage,
  projectsList,
  selectedProject,
  setSelectedProject,
}) => {
  const [page, setPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const handleRadioChange = (project) => {
    setSelectedProject(project);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleCloseModal = () => {
    setOpenProjectPage(false);
    setIsModalOpen(false);
  };

  const projectsPerPage = 6;
  const filteredProjects = projectsList.filter((project) =>
    project.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const displayedProjects = filteredProjects.slice(
    (page - 1) * projectsPerPage,
    page * projectsPerPage
  );

  return (
    <>
      <ThemeProvider theme={theme}>
        <Modal
          open={true}
          onClose={handleCloseModal}
          aria-labelledby="import-test-description-title"
          aria-describedby="import-test-description-instructions"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "550px",
              height: "500px",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 3,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              outline: "none",
            }}
          >
            <IconButton
              onClick={handleCloseModal}
              sx={{
                position: "absolute",
                top: "8px",
                right: "8px",
              }}
            >
              <CloseIcon />
            </IconButton>
            <Typography
              id="import-test-description-title"
              variant="h6"
              sx={{ textAlign: "left", mb: 2 }}
            >
              {taskType} {issueType}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography
                id="import-test-description-instructions"
                variant="subtitle2"
                sx={{ textAlign: "left", color: "text.secondary" }}
              >
                Select a project to move forward
              </Typography>
              <TextField
                size="small"
                placeholder="Search projects"
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setPage(1);
                }}
                sx={{ width: "200px", ml: 2 }}
                InputProps={{
                  endAdornment: (
                    <SearchIcon sx={{ color: "#888", cursor: "pointer" }} />
                  ),
                }}
              />
            </Box>

            {projectsList.length === 0 && !projectsLoading && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "100%",
                }}
              >
                {projectsLoading ? (
                  <CircularProgress />
                ) : (
                  <Typography>No Projects found</Typography>
                )}
              </Box>
            )}

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: 1.5,
                flex: 1,
                overflowY: "auto",
              }}
            >
              {displayedProjects.map((project, index) => {
                return (
                  <Card
                    key={index}
                    variant="outlined"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "250px",
                      height: "90px",
                      p: 1,
                      borderRadius: 2,
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        ml: -1,
                      }}
                    >
                      <Radio
                        checked={selectedProject?.id === project.id}
                        onChange={() => handleRadioChange(project)}
                        value={project}
                        name="qtest-project-radio"
                        inputProps={{ "aria-label": project.name }}
                        // sx={{ p: 0, mr: 1 }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          textAlign: "left",
                        }}
                      >
                        {project.name}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ ml: 4 }}
                    >
                      ID: {project.id}
                    </Typography>
                  </Card>
                );
              })}
            </Box>
            <Pagination
              count={Math.ceil(filteredProjects.length / projectsPerPage)}
              page={page}
              onChange={handlePageChange}
              sx={{ mt: 2, display: "flex", justifyContent: "center" }}
            />
          </Box>
        </Modal>
      </ThemeProvider>
    </>
  );
};

export default QTestProjectsComponentPages;
